import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { MobileService } from '../mobile/mobile.service';

@Directive({
  selector: '[yatAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {
  constructor(private element: ElementRef<HTMLElement>, private mobileService: MobileService) {}

  @Input('yatAutoFocus')
  active: boolean | '' = '';

  ngAfterViewInit(): void {
    if (this.active === true || this.active === '') {
      if (!this.mobileService.isMobileScreenSize()) {
        setTimeout(() => this.getFocusableElement()?.focus(), 0);
      }
    }
  }

  private getFocusableElement(): HTMLElement | null {
    const element = this.element.nativeElement;
    const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    if (element.matches(focusableSelector)) {
      return element;
    } else {
      return element.querySelector(focusableSelector);
    }
  }
}
